/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_Test_FailInputs */

const cs_sklik_test_fail = /** @type {(inputs: Sklik_Test_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test Sklik selhal`)
};

const en_sklik_test_fail = /** @type {(inputs: Sklik_Test_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklik test failed`)
};

/**
* | output |
* | --- |
* | "Sklik test failed" |
*
* @param {Sklik_Test_FailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_test_fail = /** @type {((inputs?: Sklik_Test_FailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_Test_FailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_test_fail(inputs)
	return cs_sklik_test_fail(inputs)
});